import classNames from "classnames";
import { useEffect, useState } from "react";
import { calTotalLeasing } from "../utils/leasing.u";

const FootageRowSubInfo = ({
  render,
  index,
  accessor,
  pre_installment,
  pre_installment_index,
  primaryIndex,
  loan,
  isPlus,
  setHeaderTotal,
  headerTotal,
  expanded,
}) => {
  const [localIsPlus, setLocalIsPlus] = useState(true);

  useEffect(() => {
    setLocalIsPlus(getDefaultExpanded());
  }, [expanded]);

  const getDefaultExpanded = () => {
    if (Object.keys(expanded).length > 0) {
      if (expanded[primaryIndex]) {
        return isPlus;
      }
    }
    return true;
  };

  const onClickIsPlus = (is_true) => {
    setLocalIsPlus(is_true);
    if (!is_true) {
      setHeaderTotal((prev) => prev + calTotalLeasing(pre_installment, loan));
    } else {
      setHeaderTotal((prev) => prev - calTotalLeasing(pre_installment, loan));
    }
  };

  return (
    <td
      key={index}
      className={classNames("p-4 text-gray-700 text-xs text-center", {
        // "bg-red-100": pre_installment.pre_type === "LATE",
        // "bg-green-100": pre_installment.pre_type === "OVERFLOW",
        // "bg-red-100": pre_installment.pre_type === "LATE",
        "bg-sky-100":  pre_installment.pre_status === "PENDING",
        "bg-gray-200": pre_installment.pre_status !== "PENDING",
      })}
    >
      {index !== 0 && render ? (
        render({
          pre_installment,
          pre_installment_index,
          index,
          primaryIndex,
          isPlus,
          localIsPlus,
          setLocalIsPlus,
          onClickIsPlus,
          setHeaderTotal,
          headerTotal,
          loan,
        })
      ) : (
        <div>{pre_installment[accessor]}</div>
      )}
    </td>
  );
};

export default FootageRowSubInfo;
